import Obfuscate from "react-obfuscate";

const TeamData = [
  [
    "Group Leader",
    {
      name: "Steffen Eger",
      image: require("./images/SteffenEger.jpg"),
      role: "Group Leader",
      description: (
        <div>
          <p>
            I am{" "}
            <a
              class="link"
              href="https://www.utn.de/person/prof-dr-steffen-eger/"
            >
              Heisenberg Professor
            </a>{" "}
            at University of Technology Nuremberg (UTN). Before that, I was (i) a Heisenberg Group Leader at University of Mannheim and (ii) an Interim Professor,
            substituting Philipp Cimiano in the Semantic Computing Group, at
            Bielefeld University and (iii) an 
            <a
              class="link"
              href="https://www.informatik.tu-darmstadt.de/aiphes/aiphes/irg_position/index.en.jsp"
            >
              {" "}
              Independent (Junior) Research Group Leader (IRGL)
            </a>{" "}
            ``NLP for the Humanities'' at TU Darmstadt. I obtained my PhD in
            economics on the topic of{" "}
            <a class="link" href="http://adiuvaris.org/main.pdf">
              Social Learning/Opinion Dynamics
            </a> at Goethe University Frankfurt am Main.
          </p>
          <p>
            My research interests include a variety of topics at the
            intersection of Natural Language Processing (NLP), Machine Learning,
            and applications in the Digital Humanities and Social Sciences. For
            more information, see the{" "}
            <a href="https://nl2g.github.io/">group homepage</a> and my{" "}
            <a href="https://steffeneger.github.io/">personal homepage</a>.
          </p>
          <p>
            <strong>Email:</strong> steffen.eger(at)utn.de <br />{" "}
            <a
              class="link"
              href="https://scholar.google.com/citations?user=TnuqAW0AAAAJ&hl=de&oi=ao"
            >
              Google Scholar
            </a>{" "}
            |{" "}
            <a class="link" href="https://github.com/SteffenEger">
              Github
            </a>{" "}
            |{" "}
            <a class="link" href="https://twitter.com/egere14">
              Twitter
            </a>
          </p>
        </div>
      ),
    },
  ],
  [
    "PostDocs / Research Scientists",
    {
      name: "Maria Kunilovskaya",
      image: require("./images/maria.jpg"),
      email: "maria.kunilovskaya@utn.de",
      role: "PostDoc / Research Scientist",
      description: (
                <div class="profile">
                    <p>
                      I am joining the NLLG as a postdoctoral researcher, where I will work on the <a href="https://gepris.dfg.de/gepris/projekt/465339976?language=en">
                        Conceptualizing Reconfiguration for Empirical Research
                      </a> subproject within the <em>Reconfiguration and Internalization of Social Structure (RISS CoRE)</em> initiative.
                    </p>

                    <p>
                      This move marks my second major career shift—and a long-awaited step into computational social science. 
                      For years, I explored this area through side projects, working on topics such as propaganda and social media analysis. 
                      I am excited to now pursue these interests as part of my core research.
                    </p>

                    <p>
                      My academic background is rooted in translation studies and contrastive linguistics. 
                      I spent most of my career as an Associate Professor at a Russian university before transitioning more fully into computational work, 
                      following a second PhD in computational linguistics in the UK.
                    </p>

                    <p>
                      My research has focused on translation quality estimation (for both human and machine translation) and on translationese. 
                      I have extensive experience in human annotation experiments and in building linguistic resources, especially parallel corpora. 
                      More recently, I have been working on applying information-theoretic approaches to the study of mediated language, 
                      across both written and spoken modalities.
                    </p>

                    <p>
                      Outside of research, I enjoy cycling and gardening. And I consume a lot of audiobooks while commuting by bike.
                    </p>

                    <p>
                      My current challenges include passing the German B2 TELC exam and, more ambitiously, consistently fitting eight hours of sleep into a 24-hour day. 
                    </p>
                    
                    <p>
                    I do a fair amount of reviewing, which involves careful reading, but my preferred mode is writing, ranging from academic work to travelogues and occasional blog posts, documenting important events or ideas that I go through. 
                    
                  </p>

                    <p>
                    <a href="https://datasci.social/@mariaku" rel="noopener">Mastodon</a> | <a href="https://kunilovskaya.github.io/">Homepage</a> | <a href="https://scholar.google.com/citations?user=kM1BnZYAAAAJ&hl=en">Google Scholar</a>
                    </p>

                  </div>
                  ),
    },
    {
      name: "Yamen Ajjour",
      image: require("./images/yamen.jpg"),
      email: "yamen.ajjour@utn.de",
      role: "PostDoc / Research Scientist",
      description: (
                <div class="profile">
                    <p>I am a Postdoctoral Researcher specializing in AI Safety and a member of
                      the AliAS team within the NLLG group. My current research focuses on
                      Authorship Analysis, with a specific emphasis on impersonation defense
                      and computational efficiency. I am also investigating the mechanics of
                      digital manipulation, particularly regarding emotional persuasion.
                     </p>
                    <p>
                      Prior to my current role, I earned a PhD in framing and argument
                      technology from Bauhaus-Universität Weimar and completed a PostDoc at
                      Leibniz University Hannover focused on priming and benchmarking human
                      reasoning in LLMs. Outside of research, I am an avid swimmer.
                    </p>
                    <p>
                      <a href="https://www.linkedin.com/in/yamen-ajjour-a5640913b/" target="_blank" rel="noopener noreferrer">LinkedIn</a> | 
                      <a href="https://scholar.google.com/citations?user=PDrc-BUAAAAJ" target="_blank" rel="noopener noreferrer">Google Scholar</a>
                      | <a href="https://github.com/YamenAjjour" target="_blank" rel="noopener noreferrer">Github</a>
                    </p>
                  </div>
                  ),
    },
    {
      name: "Koel Dutta Chowdhury",
      image: require("./images/koel.jpeg"),
      email: "koel.dutta.chowdhury@utn.de",
      role: "PostDoc / Research Scientist",
      description: (
                <div class="profile">
                    <p>I am a Postdoctoral Researcher in Natural Language Processing (NLP) working on multilingual and trustworthy AI. My current research focuses on understanding large language models from two complementary perspectives: (1) how models acquire, represent, and use knowledge, with a particular interest in knowledge provenance and model verification, and (2) how they represent and use linguistic variation, with applications to multilinguality, fairness, and trustworthy AI.</p>
                    <p>Previously, I received a PhD in Computational Linguistics from Saarland University, where I studied how non-native and non-standard language varieties are often misrepresented in NLP systems, shaping my broader interest in fairness and multilingual NLP. Before that, I completed a Master's in Computer Science at Dublin City University, where I explored multimodal interactions for neural machine translation.</p>
                  </div>
                  ),
    }
  ],
  [
    "PhD Students",
    {
      name: "Jonas Belouadi",
      image: require("./images/JonasBelouadi.jpg"),
      role: "PhD Student",
      description: (
        <div>
          <p>
            Greetings! I'm a PhD student at the University of Mannheim, still a
            work-in-progress, much like my research. Before starting my journey
            here, I received my master's degree with honors from TU Darmstadt,
            where I first discovered my passion for Machine Learning and Natural
            Language Processing (NLP).
          </p>
          <p>
            I'm particularly interested in mitigating low-resource limitations
            in large language models through use of synthetic data. This
            multifaceted topic has enabled me to work on (i) the development of
            unsupervised evaluation metrics for machine translation of
            low-resource languages, (ii) the creation of language models
            capable of generating style-conditioned poetry without the need for
            manually imposed stylistic constraints, and (iii) the automated
            synthesis of scientific vector graphics through the language
            modeling of graphics programming languages, such as Ti<em>k</em>Z.
          </p>
          <p>
            Beyond the computational realm, I also have a love for classical
            philology and learning new languages. It's a great way to expand my
            own knowledge and alleviate the burden on NLP models.
          </p>
          <p>
            If you have any questions or would like to know more about my work,
            please don't hesitate to reach out. I'm always happy to connect with
            others who share my interests.
          </p>
          <p>
            <table>
              <tr>
                <th>Email:</th>
                <td>
                  <Obfuscate
                    class="link"
                    email="jonas.belouadi@uni-mannheim.de"
                  />
                </td>
              </tr>
              <tr>
                <th>GitHub:</th>
                <td>
                  <Obfuscate class="link" href="https://github.com/potamides">
                    github.com/potamides
                  </Obfuscate>
                </td>
              </tr>
              <tr>
                <th>LinkedIn:</th>
                <td>
                  <Obfuscate
                    class="link"
                    href="https://linkedin.com/in/belouadi"
                  >
                    linkedin.com/in/belouadi
                  </Obfuscate>
                </td>
              </tr>
            </table>
          </p>
        </div>
      ),
    },
    {
      name: "Christoph Leiter",
      image: require("./images/ChristophLeiter.jpg"),
      role: "PhD Student",
      description: (
        <div>
          <p>
            As a third-year PhD student at University of Mannheim, I am working
            with the NLLG group to research and create explainable and robust
            metrics for generative AI. Through six years of dual bachelor- and master- studies
            with Hewlett-Packard Enterprise and DXC Technology, as well as
            another year where I worked as a technical consultant, I got the
            opportunity to collect working experience in various fields,
            including Data Engineering, Data Science and Autonomous Driving. I
            received my masters degree with honors at the TU Darmstadt, where I
            pursued my key interests in Natural Language Processing, Deep
            Learning and Computer Vision. My thesis focused on exploring
            techniques for the explainability of machine translation evaluation
            metrics.
          </p>
          <p>
            I am especially interested in the generation of text (like machine translations and summaries) and images, as well as the metrics that evaluate them. This particulary includes:
            <ul>
              <li key="uniqueId20">
                <b>Explainability</b>: Relying on metrics without knowing their
                internal workings might create a false impression of the data
                they are grading. Hence, real world applications require
                explainable metrics that can be understood by developers and
                users.
              </li>
              <li key="uniqueId21">
                <b>Robustness</b>: Closely related to explainability, robustness is the ability of a metric to provide consistent results across different datasets and models. 
                This is crucial for the reliability of the metric and the models it evaluates.
              </li>
            </ul>
          </p>
          <p>Feel free to reach out to me!</p>
          <p>
            <table>
              <tr>
                <th>Email:</th>
                <td>
                  <Obfuscate
                    class="link"
                    email="christoph.leiter@uni-mannheim.de"
                  />
                </td>
              </tr>
              <tr>
                <th>GitHub:</th>
                <td>
                  <Obfuscate class="link" href="https://github.com/Gringham">
                    github.com/Gringham
                  </Obfuscate>
                </td>
              </tr>
              <tr>
                <th>LinkedIn:</th>
                <td>
                  <Obfuscate
                    class="link"
                    href="https://linkedin.com/in/christoph-leiter-0883b515b"
                  >
                    linkedin.com/in/christoph-leiter-0883b515b
                  </Obfuscate>
                </td>
              </tr>
            </table>
          </p>
        </div>
      ),
    },
    {
      name: "Daniil Larionov",
      image: require("./images/DaniilLarionov.jpeg"),
      role: "PhD Student",
      email: "daniil.larionov@uni-mannheim.de",
      description: (
        <div>
          <p>
            I am a first-year Ph.D. student at University of Mannheim. Before
            that, I obtained my master's degree in Computational linguistics
            from HSE University, supervised by Dr. Artem Shelmanov. I've also
            worked at NLP Lab at FRC CSC RAS.
          </p>
          <p>
            I am interested in Natural Language Processing, Deep Learning,
            efficiency, and uncertainty estimation:
            <ul>
              <li key="uniqueId22">
                Text Generation and its efficient evaluation. Text style
                transfer, dialogue agents, machine translation.
              </li>
              <li key="uniqueId23">
                Distillation, quantization of deep learning models. Efficient
                implementations of DL-related operations.
              </li>
              <li key="uniqueId24">Active Learning and uncertainty estimation.</li>
            </ul>
            I'm a native speaker of Russian and fluent in English.
          </p>
          <p>
            <a
              class="link"
              href="https://scholar.google.com/citations?hl=en&view_op=list_works&authuser=2&gmla=AJsN-F56coF61cTUGPdchlXACkFRLK3oUxFK0vxY7eAUpugnOUnLBZF5vmVtL4FK3_zRAipkFlA6PUCDHjxL0cKwBFVeVn7g2g&user=kvsOlOQAAAAJ"
            >
              Google Scholar
            </a>{" "}
            |{" "}
            <a class="link" href="https://github.com/Rexhaif">
              Github
            </a>
          </p>
        </div>
      ),
    },
    {
      name: "Ran Zhang",
      image: require("./images/ZhangRan.jpeg"),
      role: "PhD Student",
      email: "ran.zhang@uni-mannheim.de",
      description: (
        <div>
          <p>
            I am a freshly-baked Ph.D. student at University of Mannheim. Before
            that, Humboldt-Universität zu Berlin kindly awards me my master's
            degree in Statistics (yet not kind enough to award me another degree
            in mathematics). I was hired as a GPU burner at data science lab in
            Hertie School of Governance for a year, digging causal languages of
            political texts from the ashes.
          </p>
          <p>
            Now my interests are to keep burning GPUs in Mannheim on
            fascinating topics such as :
            <ul>
              <li key="uniqueId25">Developing metrics to quantify human-unreadable texts.</li>
              <li key="uniqueId26">
                Generating poetry that even Shakespeare could not comprehend.
              </li>
              <li key="uniqueId27">
                Summarising historical texts which ends up as creative writing.
              </li>
            </ul>
            My interests are steadily growing and I am learning my fourth
            language taught by machines apart from 100% Chinese, 80% English,
            and 50% German.
          </p>
        </div>
      ),
    },
    {
      name: "Yanran Chen",
      image: require("./images/YanranChen.jpg"),
      role: "PhD Student",
      email: "yanran.chen@uni-mannheim.de",
      description: (
        <div>
          <p>
          I'm a first-year PhD student at University of Mannheim. Before that, I earned my bachelor's and master's degrees from TU Darmstadt. 
          I discovered my passion for programming when starting as an electrical engineering student at TU Darmstadt, which prompted my 
          transition to iST—an interdisciplinary major in computer science and electrical engineering—during my Bachelor's. This move paves 
          the way for my specialization in computer science, particularly in NLP, during the master's phase. As someone who struggles with 
          language learning, I've always been fascinated by AI's great power in navigating human language; I hope people like me can truly 
          benefit from AI and NLP technology. 
          </p>
          <p>
          During my time as a student assistant at NLLG, I worked on text generation and evaluation metrics. 
          Now, in my PhD journey, I'm primarily interested in argument generation, focusing on:
          <ul>
              <li key="uniqueId28">Exploring the role of emotions in convincingness of arguments</li>
              <li key="uniqueId29">
              Generating emotion-bias / fallacy free but convincing arguments.
              </li>
            </ul>
          </p>
          <p>
            <a
              class="link"
              href="https://scholar.google.com/citations?user=K0iCb00AAAAJ&hl=en&oi=ao"
            >
              Google Scholar
            </a>{" "}
            |{" "}
            <a class="link" href="https://github.com/cyr19">
              Github
            </a>
          </p>
        </div>
      ),
    },
    {
      name: "Christian Greisinger",
      image: require("./images/christian_greisinger.jpg"),
      role: "PhD Student",
      email: "christiangreisinger33@outlook.de",
      description: (
        <div>
          <p>Servus! I am a new PhD student in the Natural Language Learning and Generation Lab at the University of Technology Nuremberg, focusing on NLP for Science. My research explores how Large Language Models can support the entire scientific workflow—from generating innovative ideas to reviewing the final outcomes.</p>
          <p>Before starting my PhD, I completed a Bachelor's degree in Mechatronics/Precision Engineering and a Master's degree in Electronic and Mechatronic Systems at the Nuremberg Institute of Technology. During this time, I also participated in a dual study program at Siemens AG Digital Industries, where I contributed to projects in Computer Vision, Explainable AI, Interactive Learning, and LLMs. Notable work includes using passive human gaze data to enhance CNN performance and leveraging vision-language models to debug task-specific vision systems. These experiences deepened my interest in AI and NLP, inspiring me to pursue cutting-edge research with this talented group of people.</p>
          <p>Outside of academia, I enjoy a variety of sports like badminton, table tennis, and tennis. Occasionally, you might also find me sharpening my strategic thinking skills with a game of chess.</p> 
          <p>Feel free to connect if you'd like to discuss research or other topics!</p>
          <p>
            <a
              class="link"
              href="https://de.linkedin.com/in/christian-greisinger-733405242"
            >
              LinkedIn
            </a>{" "}
            |{" "}
            <a class="link" href="https://github.com/chris-greisi">
              Github
            </a>
          </p>
        </div>
      ),
    },
    {
      name: "Subhadeep Roy",
      image: require("./images/subhadeep_roy.jpg"),
      role: "PhD Student",
      email: "imsubhadeeproy@gmail.com",
      description: (
        <div>
          <p>Hello! I am a new PhD student at the University of Technology Nuremberg, working with the NLLG group to explore multi-modal evaluation metrics and other exciting topics in NLP and deep learning. Before joining the PhD program, I completed my MSc in Data Science and AI at the University of Liverpool, where I focused on Legal-NLP, particularly perspective-based summarization and simplification of legal texts.</p>
          <p>My research interests lie in the intersection of Natural Language Processing (NLP) and deep learning, with a particular focus on tasks like text summarization, evaluation metrics, and multi-modal NLP. As part of my PhD journey, I aim to delve deeper into these areas and contribute to innovative solutions, working alongside an incredible group of researchers at NLLG.</p>
          <p>Outside of my research, I am passionate about exploring how NLP can be applied to create more transparent and accessible systems.</p>
          <p>If you'd like to connect or know more about my work, feel free to reach out!</p>
          <p>
            <a
              class="link"
              href="https://linkedin.com/in/subhadeeproy01"
            >
              LinkedIn
            </a>{" "}
            |{" "}
            <a class="link" href="https://github.com/subha-roy">
              Github
            </a>
          </p>
        </div>
      ),
    },
    {
      name: "Zhipin Wang",
      image: require("./images/zhipin_wang.jpg"),
      role: "PhD Student",
      email: "zpwang99@foxmail.com",
      description: (
        <div>
          <p>Hello! I am a new PhD student in the NLLG group at the University of Technology Nuremberg, focusing on improving language understanding and refining content generation. My research aims to enhance the quality and relevance of textual outputs while aligning them with diverse needs.</p>
          <p>I received my Bachelor’s degree from Harbin Institute of Technology, China. I then earned my Master’s degree from Beihang University, China, where I focused on integrating information from different modalities and designing frameworks and tools to address practical daily life challenges. Coming from an engineering background, I have spent much of my time working with data and code. This has deepened my appreciation for language and literature, as they bring a sense of warmth that complements the precision of technical work, inspiring my research into structured approaches to enhance textual outputs.</p>
          <p>At NLLG, I am excited to collaborate with talented researchers to explore new possibilities in textual systems, aiming to enhance the robustness and adaptability.</p>
          <p>Beyond research, I enjoy playing piano and soccer, which offer creative and refreshing ways to balance my academic pursuits.</p>
          <p>Feel free to reach out if you'd like to discuss research, collaborate, or other topics!</p>
        </div>
      ),
    },
    {
      name: "Gagan Bhatia",
      image: require("./images/Gagan.jpeg"),
      email: "gagan.bhatia@utn.de",
      role: "PhD Student",
      description: (
      <div>
        <p> I am a PhD student in the NLLG group at the University of Technology Nuremberg, where I focus on understanding and explaining social bias in large language models, with the broader goal of making LLMs safer and more inclusive for a wider audience. I completed my bachelor’s degree at the University of British Columbia, where I worked on building new Arabic LLMs and improving financial LLMs. I later earned my master’s degree from the University of Aberdeen, where I focused on temporal reasoning and LLM interpretability. Outside of research, I love dancing and I am currently hoping to get into running. </p> <p> Please feel free to reach out if you would like to connect, collaborate, or chat about research. </p> <p> Email: <a href="mailto:gagan.bhatia@utn.de">gagan.bhatia@utn.de</a> | Scholar: <a href="https://scholar.google.com/citations?user=2Z0KWkEAAAAJ&amp;hl=en">Google Scholar</a> | LinkedIn: <a href="https://www.linkedin.com/in/gaganbhatiaml/">LinkedIn</a> | GitHub: <a href="https://github.com/gagan3012">GitHub</a> 
        </p>
      </div>
      ),
    },
  ],
  [
    "External PhD Candidates",
    {
      name: "Lotta Kiefer",
      image: require("./images/LottaKiefer_Picture.jpg"),
      role: "External PhD Candidate",
      description: (
        <div>
          <p>Hello! I’m a new PhD student at the University of Technology Nuremberg. My research focuses on the use of NLP for authorship analysis, with an emphasis on forensic contexts.
            I'm interested not only in enhancing existing methods and developing new approaches, but also in improving their robustness and incorporating explainability as key steps
            toward making these solutions practical and reliable for real-world investigative use.</p>
          <p>Before starting my PhD, I earned a Bachelor's degree in Linguistics from the University of Konstanz
            and a Master's degree in Language Science and Technology from Saarland University. For the research of my Master's thesis, I spent six months with the NLP research group at Stockholm University, where I worked on generating synthetic electronic health records to support the development of privacy-preserving clinical NLP systems.</p>
          <p>Outside of academia, I enjoy swimming and running, love exploring new places and am a big fan of coffee and cats.</p>
          <p>I’m looking forward to being part of this research group and am excited to see where this journey takes me.</p>
          <p>If you'd like to connect, feel free to reach out!</p>
          <p>
            <a class="link" href="https://www.linkedin.com/in/lotta-kiefer-822995291/">LinkedIn</a> | <a class="link" href="https://github.com/lottaKiefer">Github</a>
          </p>
        </div>
      ),
    },
  ],
    [
    "Associated",
        {
      name: "Aida Kostikova",
      image: require("./images/AidaKostikova.jpg"),
      role: "Associated PhD Student",
      email: "aida.kostikova@uni-bielefeld.de",
      description: (
        <div>
          <p>
            Hello! I'm Aida Kostikova, currently doing my Ph.D. at Bielefeld
            University, where I'm focused on the field of Large Language Models
            (LLMs). But before I found myself in this domain, I went on quite a
            journey.
          </p>
          <p>
            I started my professional life as a translator, which sparked my
            interest in how languages work and how they can be understood not
            only by humans but also by machines. My curiosity then led me to
            study Intercultural Communication in Politics and Diplomacy at
            Moscow State University, where I realised the potential of
            interdisciplinary studies and how different fields could provide
            valuable insights to each other.
          </p>
          <p>
            Afterwards, I moved on to the European Master’s in Technologies for
            Translation and Interpreting (EM TTI) Programme at New Bulgarian
            University and Ghent University. It was there that I first
            discovered the broader field of Natural Language Processing (NLP).
            This experience marked a turning point in my journey, steering me
            towards NLP in general, and specifically, Large Language Models.
          </p>
          <p>
            Now, in my Ph.D. journey, I work with LLMs every day, examining
            them, finding errors, and learning about their strengths and
            limitations, and one of the intriguing aspects of my research
            involves the application of these models in the domain of social and
            political sciences. My ultimate goal is to enhance these models,
            striving for better accuracy, reliability, and sustainability as
            they continue to evolve.{" "}
          </p>
          <p>
            Stepping into this Ph.D. has been a thrilling ride, and I am looking
            forward to where this exciting field will take me next.
          </p>
        </div>
      ),
    },
    {
      name: "Kilian Rueß",
      image: require("./images/dummy.jpg"),
      email: "Follows",
      role: "Associated",
      description: <div>Follows</div>,
    },
  ],
  [
    "Secretaries",
    {
      name: "Corinna Dannewitz",
      image: require("./images/dummy.jpg"),
      email: "department-eng@utn.de",
      role: "Secretary",
      description: <div>Follows</div>,
    },
    {
      name: "Cathrin Titschak / Andrea Smith",
      image: require("./images/dummy.jpg"),
      email: "department-eng@utn.de",
      role: "Secretary",
      description: <div>Follows</div>,
    },
    {
      name: "Jennifer Graber",
      image: require("./images/dummy.jpg"),
      email: "jennifer.graber@uni-mannheim.de",
      role: "Secretary",
      description: <div>Follows</div>,
    },
  ],
  [
    "Interns",
    {
      name: "Lisa Sophie Albertelli",
      image: require("./images/dummy.jpg"),
      email: "Follows",
      role: "Intern",
      description: <div>Follows</div>,
    },
  ],
  [
    "Hiwis",
    {
      name: "Follows",
      image: require("./images/dummy.jpg"),
      role: "Hiwi",
      description: <div>Follows</div>,
    },
  ],
  [
    "Former Members",
    {
      name: "Sotaro Takeshita",
      image: require("./images/sotaro.jpeg"),
      role: "Former PostDoc / Research Scientist",
      description: (
        <div>
        <p>
          Hi, I am a PhD student at the University of Mannheim and a researcher at the University of Technology Nuremberg. I am interested in:
        </p>
        <p>
          <ul>
              <li key="uniqueId20d">
                Text summarization for scholarly documents.
              </li>
              <li key="uniqueId21e">
                Understanding properties of text embeddings.
              </li>
            </ul>
          </p>
          <p>Outside of research, I like coffee, anime and video games.</p>
        <p>
            <table>
              <tr>
                <th>Email:</th>
                <td>
                  <Obfuscate
                    class="link"
                    email="sotaro.takeshita@uni-mannheim.de"
                  />
                </td>
              </tr>
              <tr>
                <th>Website:</th>
                <td>
                  <Obfuscate class="link" href="https://sotaro.io/about">
                    https://sotaro.io/about
                  </Obfuscate>
                </td>
              </tr>
              <tr>
                <th>GitHub:</th>
                <td>
                  <Obfuscate
                    class="link"
                    href="https://github.com/sobamchan/"
                  >
                    https://github.com/sobamchan/
                  </Obfuscate>
                </td>
              </tr>
            </table>
          </p>
        </div>
      ),
    },
    {
      name: "Dr. Wei Zhao",
      image: require("./images/dummy.jpg"),
      role: "Former PhD Student",
      description: (
        <div>Follows</div>
      ),
    },
    {
      name: "Humaun Kabir",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern in 2024</div>,
    },
    {
      name: "Leixin Zhang",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern in 2024</div>,
    },
    {
      name: "Daniil Bergman",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Finland in 2023</div>,
    },
    {
      name: "Shahin Yousefi",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Iran in 2023</div>,
    },
    {
      name: "Hoa Nguyen",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Germany in 2022</div>,
    },
    {
      name: "Ayodele Awokoya",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Nigeria in 2022</div>,
    },
    {
      name: "Dominik Beese",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Germany in 2022</div>,
    },
    {
      name: "Görkem Güzeler",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Finland in 2021</div>,
    },
    {
      name: "Begüm Altunbas",
      image: require("./images/dummy.jpg"),
      role: "Former Intern",
      description: <div>Intern from Turkey in 2021</div>,
    },
    {
      name: "Vivian Fresen",
      image: require("./images/dummy.jpg"),
      role: "Former Hiwi",
      description: <div>Follows</div>,
    },
  ],
];

export default TeamData;
